
const WineMenuSelectors = {
    select: '[data-wines-select]'
};

class WineMenu {

    constructor(elem) {

        this.elem = elem;

        if (!this.elem) return;

        this.bindEvents();
    }

    bindEvents() {
        this.elem.addEventListener('change', this.toggle.bind(this));
    }

    toggle() {

        let selectedOption = this.elem.options[this.elem.selectedIndex];
        let optionUrl = selectedOption.value;

        if (optionUrl) {
            window.location.href = optionUrl;
        }


    }

}

document.querySelectorAll(WineMenuSelectors.select).forEach(elem => new WineMenu(elem) );
